export const LogoMark = ({ className = "w-9 h-9", dark = false }) => (
  <img
    src={dark ? "/assets/logo-mark-light.png" : "/assets/logo-mark.png"}
    alt=""
    aria-hidden="true"
    className={`object-contain ${className}`}
  />
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark dark={dark} className="h-10 w-auto" />
    <span className="leading-none">
      <span className={`block font-display font-extrabold tracking-tight text-lg ${dark ? "text-avorio" : "text-antracite"}`}>
        ALSERA
      </span>
      <span className="block text-[0.6rem] font-semibold tracking-[0.34em] text-elettrico">
        STUDIO
      </span>
    </span>
  </span>
);
